import { StatsApiClient } from "../../clients/stats-client";
import { LeaderboardPlayer } from "./models/leaderboard";

export class LeaderboardRepository {
    private _client: StatsApiClient;

    constructor() {
        this._client = new StatsApiClient('/api/v2/leaderboard');
    }

    async get(): Promise<ApiDataResponse<LeaderboardPlayer[]>> {
        return await this._client.get<LeaderboardPlayer[]>("");
    }
}